export let Platform;

(function (Platform) {
  Platform["Mobile"] = "Mobile";
  Platform["Desktop"] = "Desktop";
})(Platform || (Platform = {}));